import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    faCalendar,
} from '@fortawesome/free-solid-svg-icons';
import Title from 'components/UI/Title';
import Skeleton from 'components/UI/Skeleton';
import { connect } from 'react-redux';
import _ from 'lodash';
import DestinationDocuments from 'components/BusinessLogic/DestinationDocuments/Card';
import RequestDocuments from 'components/BusinessLogic/RequestDocuments/Card';
import RequestSummary from 'components/UI/RequestSummary';
import RequestHeaders from 'components/UI/RequestHeaders';
import { loadRequest, requestDetailsIncludes } from 'store/dispatchers/requests.dispatchers';
import PropTypes from 'prop-types';
import { buildMetaRequestSelector, buildRequestSelector } from 'store/selectors/requests.selector';
import { compose } from 'redux';
import { withRouteParams } from 'hoc/withRouteParams';
import { containsIncludes } from 'store/dispatchers/helpers';
import ErrorMessage from 'components/UI/ErrorMessage';
import { Helmet } from 'react-helmet';

function RequestDetail({
    getRequest, request, metaRequest, isB2cPage,
})
{
    const { id } = useParams();
    const loadData = async () =>
    {
        if (metaRequest.needUpdate === true || _.isEmpty(request) || !containsIncludes(requestDetailsIncludes, metaRequest?.loadedIncludes))
        {
            getRequest(id).then((result) =>
            {
                if (result?.httpClientResponse?.status === 403)
                {
                    window.location.replace('/requests');
                }
            });
        }
    };

    useEffect(() =>
    {
        loadData();
    }, [metaRequest]);

    return (
        <div className="tw-flex tw-flex-col tw-flex-1 tw-w-full h-full tw-overflow-y-auto tw-p-10 lg:tw-pl-[248px]">
            <div className="tw-flex tw-justify-between tw-items-center ">
                {
                    request.id ? (
                        <Title
                            title={`Quote #${request.id}`}
                            icon={faCalendar}
                        />
                    ) : (
                        <Skeleton type="title" className="tw-w-full" />
                    )
                }
            </div>
            <ErrorMessage errorMessage={metaRequest.error} />

            {request?.id ? (<RequestHeaders isB2cPage={isB2cPage} requestId={request.id} />) : (<Skeleton type="list" />) }
            {request?.id ? (<RequestSummary isB2cPage={isB2cPage} requestId={request.id} />) : (<Skeleton type="list" />) }
            {request && request.requestHotels ? (<DestinationDocuments requestId={request.id} />) : (<Skeleton type="box" className="tw-w-full" />) }
            {request?.id ? (<RequestDocuments requestId={request.id} />) : (<Skeleton type="box" className="tw-w-full" />)}

            {request?.id
            && (
                <Helmet title={`Request Quote #${request.id} | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                    <meta name="description" content={`Request Quote #${request.id}`} />
                </Helmet>
            )}

        </div>
    );
}

RequestDetail.defaultProps = {
    isB2cPage: false,
};

RequestDetail.propTypes = {
    isB2cPage: PropTypes.bool,
    getRequest: PropTypes.func,
    metaRequest: PropTypes.any,
    request: PropTypes.shape({
        id: PropTypes.number,
        requestHotels: PropTypes.array,
    }),
};

const mapStateToProps = () =>
{
    const requestSelector = buildRequestSelector();
    const metaRequestSelector = buildMetaRequestSelector();

    return (state, props) =>
    {
        const requestId = parseInt(props.params.id, 10);
        return {
            request: requestSelector(state, requestId),
            metaRequest: metaRequestSelector(state, requestId),
        };
    };
};

const mapDispatchToProps = (dispatch) => ({
    getRequest(requestId)
    {
        return dispatch(loadRequest(requestId, requestDetailsIncludes));
    },
});

export default compose(
    withRouteParams,
    connect(mapStateToProps, mapDispatchToProps),
)(RequestDetail);
